import { createContext, useContext, useEffect, useState } from "react";
import "./login.css"
import axios from "axios";
import { Link, Route, Routes, useNavigate } from "react-router-dom";
import RestPassword from "./RestPassword";
import Sync from "./sync";
import { loginkey } from "./LoginContext";
import { useMediaQuery } from "react-responsive";
import React from "react";
import Register from "./register";
import { loginUserId } from "./LoginUserIdContext";
import { loginOrRegister } from "./LoginOrRegisterContext";
import { MdInfoOutline } from "react-icons/md";

export const loginAuth = createContext(null);

function LogIn(props) {
    const [message, setMessage] = useState("");
    const [messageData, setMessageData] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [register, setRegister] = useState("0");
    const [infoo, setInfoo] = useState([]);
    const [infooLogin, setInfooLogin] = useState([]);
    const [forgot, setForgot] = useState(false);
    //const [loginOrRegister, setLoginOrRegister] = useState(false)
    const [confirm, setConfirm] = useState(0);
    const { setAuth } = useContext(loginkey);
    const { setId } = useContext(loginUserId);
    const { id } = useContext(loginUserId);
    const { setLogged } = useContext(loginOrRegister)
    const { logged } = useContext(loginOrRegister)
    const domainUrl= "drclinic.hassan-mohammad.tech"
    const getLoginAllData = async () => {
        await fetch(`https://${domainUrl}/php/loginData.php`,
            {
                headers: {
                    "Content-Type": "text/html",
                    "charset": "utf-8"
                },
            }
        )
            .then((response) => {
                if (!response.ok) {
                    throw Error('Could not fetch the data')
                }
                else if (response.ok) {
                    return response.json()
                }
            })
            .then(async (data) => {
                if (data.values.length === 0) {
                    setRegister("1")
                }
                if (data.values.length > 0) {
                    setRegister("2")
                }
                return (
                    setInfooLogin(data.values));
            })
            .catch(err => {
                setMessageData(err.message)
            })
    };
    function sendEmail(event) {
        const url = `https://${domainUrl}/php/sendemailLoggedin.php`;
        const formData = new FormData();
        const config = {
            headers: {
                "Content-Type": "text/html",
                "charset": "utf-8"
            },
        };
        axios.post(url, formData, config).then(response => {
            if (response.status === 200) {
            }
        })
            .catch(error => {
                console.log(error);
            });
    }



    const getLoginFetchData = async (event) => {
        event.preventDefault();
        await fetch(`https://${domainUrl}/php/login.php?email=${email}&password=${password}`,
            {
                headers: {
                    "Content-Type": "text/html",
                    "charset": "utf-8"
                },
            }
        )
            .then((response) => {
                if (!response.ok) {
                    setMessage('loading...')
                    throw Error('Could not fetch the data')
                }
                else if (response.ok) {
                    setMessage('Done')
                    //sendEmail()
                    return response.json()
                }
            })
            .then(async (data) => {
                data.values.map((e) => {
                    setId(e.id)
                })
                if (data.values.length === 0) {
                    setMessage("Wrong username or password")
                }
                if (data.values.length > 0) {
                    /*data.values.map((e) => {
                        setId(e.id)
                    })*/
                    setConfirm(1)
                    setAuth(1);
                    setMessage('Success');
                    //handlePushState();
                    navToSync();
                }
                return (
                    setInfoo(data.values));
            })
            .catch(err => {
                setMessage(err.message)
            })
    };
    var sha1 = require('sha1');

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    }
    const handlePasswordChange = (e) => {
        setPassword(sha1(`${e.target.value}`));
    }
    const navigate = useNavigate();
    function navToRest() {
        if (email) {
            if (email === 'test@test.test') {
                setMessage("Please try another email")
            } else {
                setForgot(true)
            }
        } else {
            setMessage("Please add your email")
        }
        // navigate("/RestPassword", { replace: true });
    }

    function navToDonations() {
        navigate("/Donations", { replace: true });
    }
    function navToSync() {
        setConfirm(1);
        setAuth(1);
        navigate("/GetPatients", { replace: true });
    }
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 1224px)'
    })
    const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
    useEffect(() => {
        //getLoginAllData();
        //setPassword(sha1(`aa`));
    }, [])
    function handlePushState() {
        window.history.pushState({ id: 1 }, null, "GetPatients")
    }
    //console.log(window.location.href)
    return (
        <div>
            <div className="welcome">
                {logged && <h2 className="welcome-headertop">Welcome</h2>}
                {!logged && <h2 className="welcome-headertop">Welcome again</h2>}
                {!logged && <h6 className="welcome-header">Please Login and enjoy our services</h6>}
                {logged && <h6 className="welcome-header">Please create your account and enjoy our services</h6>}
            </div>
            {isDesktopOrLaptop && <div className="login-page">
                {logged === true && <Register />}
                {logged === false && <div className="container">
                    <div className="login-container" onSubmit={getLoginFetchData}>
                        {forgot && <RestPassword email={email} />}
                        <h6 style={{ color: 'white', border: "1px", borderStyle: 'solid', borderColor: 'white', padding: '5px', borderRadius: '1%', display: 'flex', flexDirection: 'column' }}>
                            <h6 style={{ color: 'yellow' }}>
                                <MdInfoOutline />
                            </h6>
                            For test purpose you can use:"Email:test@test.test" and "Password:test"</h6>
                        {!forgot && <form className="login-form"><h4 className="title-login">Login</h4>
                            <input type="email" className="form-control login-input" placeholder="Email" onChange={(event) => { handleEmailChange(event) }}></input>
                            <input type="password" className="form-control login-input" placeholder="Password" onChange={(event) => { handlePasswordChange(event) }}></input>
                            <div className="btn-forgot">
                                <a className="forgot-link title-login" onClick={navToRest}>Forgot my password</a>
                            </div>
                            <div className="login-btn-container">
                                <button type="submit" className="btn btn-dark login-btn">Login</button>
                            </div>
                            {message && <div className="label-text">{message}</div>}
                        </form>
                        }
                    </div>
                </div>}
            </div>}
            {isTabletOrMobile && <div className="login-page-mobile">
                {logged === true && <Register />}
                {logged === false && <div className="container-mobile">
                    <div className="login-container-mobile" onSubmit={getLoginFetchData}>
                        {forgot && <RestPassword />}
                        <h6 style={{ color: 'white', border: "1px", borderStyle: 'solid', borderColor: 'white', padding: '5px', borderRadius: '1%', display: 'flex', flexDirection: 'column' }}>
                            <h6 style={{ color: 'yellow' }}>
                                <MdInfoOutline />
                            </h6>
                            For test purpose you can use:"Email:test@test.test" and "Password:test"</h6>
                        {!forgot && <form className="login-form-mobile"><h4 className="title-login">Login</h4>
                            <input type="email" className="form-control login-input" placeholder="Email" onChange={(event) => { handleEmailChange(event) }}></input>
                            <input type="password" className="form-control login-input" placeholder="Password" onChange={(event) => { handlePasswordChange(event) }}></input>
                            <div className="btn-forgot">
                                <a className="forgot-link title-login" onClick={navToRest}>Forgot my password</a>
                            </div>
                            <div className="login-btn-container-mobile">
                                <button type="submit" className="btn btn-dark login-btn">Login</button>
                            </div>
                            {message && <div className="label-text">{message}</div>}
                        </form>
                        }
                    </div>
                </div>}
            </div>}
            <loginAuth.Provider value={confirm}>
                {props.children}
            </loginAuth.Provider>
        </div>
    );
}

export default LogIn;

/*                    <div className="donation-mobile">
                        <h6>All our services are free. But if you would like to support us</h6>
                        <h6 style={{ color: '#ffa400' }} onClick={navToDonations}>Click here</h6>
                    </div>*/